// Tienda Café — JS propio, vanilla, un archivo. Cada init comprueba si su elemento existe.
document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initHeroParallax();
  initDespiece();
  initContadores();
  initGaleriaProducto();
  initVariantesProducto();
  initPromoCarrito();
  initComboCarrito();
});

var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

function initReveal() {
  var els = document.querySelectorAll('.tc-reveal');
  if (!els.length) return;
  if (prefersReducedMotion) {
    els.forEach(function (el) { el.classList.add('tc-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var delay = entry.target.getAttribute('data-tc-delay') || 0;
        setTimeout(function () { entry.target.classList.add('tc-visible'); }, parseInt(delay, 10));
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
  els.forEach(function (el) { observer.observe(el); });
}

function initHeroParallax() {
  var hero = document.querySelector('[data-tc-parallax]');
  if (!hero || prefersReducedMotion) return;
  var img = hero.querySelector('[data-tc-parallax-img]');
  if (!img) return;
  var ticking = false;
  function update() {
    var rect = hero.getBoundingClientRect();
    if (rect.bottom < 0 || rect.top > window.innerHeight) { ticking = false; return; }
    var progress = 1 - (rect.top / window.innerHeight);
    var offset = Math.max(-40, Math.min(40, (progress - 0.5) * 60));
    img.style.transform = 'translate3d(0,' + offset + 'px,0) scale(1.06)';
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
  }, { passive: true });
  update();
}

// Escena de despiece: pin sticky + cross-fade de fotogramas según el progreso de scroll
// Despiece: una sola escena, piezas reales que se separan y vuelven a juntar
// con el scroll (animación continua por transform, no cambio de fotos).
function initDespiece() {
  var wrap = document.querySelector('[data-tc-despiece]');
  if (!wrap) return;
  var columna = wrap.querySelector('[data-tc-columna]');
  var cabecera = wrap.querySelector('.tc-despiece-cabecera');
  var escena = wrap.querySelector('.tc-despiece-escena');
  var partes = wrap.querySelectorAll('[data-tc-parte]');
  var progressBar = wrap.querySelector('[data-tc-progress-fill]');
  if (!columna || !partes.length) return;

  function easeOutCubic(t) { return 1 - Math.pow(1 - t, 3); }

  if (prefersReducedMotion) {
    partes.forEach(function (parte) {
      var label = parte.querySelector('[data-tc-parte-label]');
      if (label) label.style.opacity = 1;
    });
    return;
  }

  // Alcance vertical de la escena totalmente explosionada, medido como
  // múltiplo del ancho de la columna (derivado de las alturas reales de las
  // piezas recortadas y de los multiplicadores de separación de cada una).
  var ALCANCE_ARRIBA = 1.5516;
  var ALCANCE_ABAJO = 1.2726;
  var ANCHO_MIN = 170;
  var ANCHO_MAX = 460;

  function ajustarTamano() {
    var innerH = window.innerHeight;
    var reservado = (cabecera ? cabecera.offsetHeight : 90) + 24;
    var margen = 16;
    var wArriba = ((reservado + innerH) / 2 - margen) / ALCANCE_ARRIBA;
    var wAbajo = ((innerH - reservado) / 2 - margen) / ALCANCE_ABAJO;
    var anchoMaxViewport = window.innerWidth * (window.innerWidth <= 480 ? 0.38 : 0.62);
    var ancho = Math.max(ANCHO_MIN, Math.min(ANCHO_MAX, wArriba, wAbajo, innerH * 0.5, anchoMaxViewport));
    columna.style.width = ancho + 'px';
    if (escena) escena.style.paddingTop = reservado + 'px';
  }

  var ticking = false;
  function update() {
    var rect = wrap.getBoundingClientRect();
    var total = rect.height - window.innerHeight;
    var raw = total > 0 ? (-rect.top) / total : 0;
    var progress = Math.max(0, Math.min(1, raw));
    var eased = easeOutCubic(progress);

    var unidad = columna.clientWidth * 0.62;

    partes.forEach(function (parte) {
      var mult = parseFloat(parte.getAttribute('data-multiplicador')) || 0;
      var offset = eased * unidad * mult;
      parte.style.transform = 'translate3d(0,' + offset + 'px,0) rotate(' + (mult * eased * 1.2) + 'deg)';
      var label = parte.querySelector('[data-tc-parte-label]');
      if (label) {
        var labelOpacity = Math.max(0, Math.min(1, (progress - 0.5) / 0.32));
        label.style.opacity = labelOpacity;
      }
    });

    if (progressBar) progressBar.style.height = (progress * 100) + '%';
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
  }, { passive: true });
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () { ajustarTamano(); update(); }, 120);
  });
  ajustarTamano();
  update();
}

function initContadores() {
  var els = document.querySelectorAll('[data-tc-contador]');
  if (!els.length) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var target = parseFloat(el.getAttribute('data-tc-contador'));
      var suffix = el.getAttribute('data-tc-sufijo') || '';
      var duration = prefersReducedMotion ? 0 : 1400;
      var start = performance.now();
      function step(now) {
        var p = duration === 0 ? 1 : Math.min(1, (now - start) / duration);
        var eased = 1 - Math.pow(1 - p, 3);
        var value = target * eased;
        el.textContent = (Number.isInteger(target) ? Math.round(value) : value.toFixed(1)) + suffix;
        if (p < 1) requestAnimationFrame(step); else el.textContent = target + suffix;
      }
      requestAnimationFrame(step);
      observer.unobserve(el);
    });
  }, { threshold: 0.5 });
  els.forEach(function (el) { observer.observe(el); });
}

function initGaleriaProducto() {
  var galeria = document.querySelector('[data-tc-galeria-producto]');
  if (!galeria) return;
  var pista = galeria.querySelector('[data-tc-galeria-pista]');
  var slides = galeria.querySelectorAll('[data-tc-galeria-slide]');
  var minis = galeria.querySelectorAll('[data-tc-galeria-mini]');
  var progreso = galeria.querySelector('[data-tc-galeria-progreso]');
  var modal = document.querySelector('[data-tc-zoom-modal]');
  var modalImagen = modal && modal.querySelector('[data-tc-zoom-imagen]');
  var cerrar = modal && modal.querySelector('[data-tc-zoom-cerrar]');
  if (!pista || !slides.length) return;

  var indice = 0;

  function actualizarActiva(nueva) {
    indice = Math.max(0, Math.min(slides.length - 1, nueva));
    minis.forEach(function (mini, i) { mini.classList.toggle('tc-activa', i === indice); });
    if (progreso) progreso.style.width = (((indice + 1) / slides.length) * 100) + '%';
    slides.forEach(function (slide, i) {
      slide.querySelectorAll('video').forEach(function (video) {
        if (i === indice) {
          video.muted = true;
          var intento = video.play();
          if (intento && intento.catch) intento.catch(function () {});
        } else {
          video.pause();
        }
      });
    });
  }

  function irA(nueva, comportamiento) {
    nueva = (nueva + slides.length) % slides.length;
    pista.scrollTo({ left: slides[nueva].offsetLeft, behavior: comportamiento || 'smooth' });
    actualizarActiva(nueva);
  }

  var flechaPrev = galeria.querySelector('[data-tc-galeria-prev]');
  var flechaNext = galeria.querySelector('[data-tc-galeria-next]');
  if (flechaPrev) flechaPrev.addEventListener('click', function () { irA(indice - 1); });
  if (flechaNext) flechaNext.addEventListener('click', function () { irA(indice + 1); });

  minis.forEach(function (mini) {
    mini.addEventListener('click', function () {
      irA(parseInt(mini.getAttribute('data-tc-indice'), 10) || 0);
    });
  });

  pista.addEventListener('scroll', function () {
    var nuevo = Math.round(pista.scrollLeft / Math.max(1, pista.clientWidth));
    if (nuevo !== indice) actualizarActiva(nuevo);
  }, { passive: true });

  galeria.querySelectorAll('[data-tc-galeria-zoom]').forEach(function (boton) {
    boton.addEventListener('click', function () {
      var imagen = slides[indice].querySelector('[data-tc-galeria-imagen]');
      if (!imagen || !modal || !modalImagen) return;
      modalImagen.src = imagen.currentSrc || imagen.src;
      modalImagen.alt = imagen.alt;
      modalImagen.classList.remove('tc-zoom-activo');
      if (modal.showModal) modal.showModal();
    });
  });
  if (modal && modalImagen) {
    modalImagen.addEventListener('click', function () { modalImagen.classList.toggle('tc-zoom-activo'); });
    if (cerrar) cerrar.addEventListener('click', function () { modal.close(); });
    modal.addEventListener('click', function (event) { if (event.target === modal) modal.close(); });
  }

  pista.scrollLeft = 0;
  actualizarActiva(0);
}

function initVariantesProducto() {
  var form = document.querySelector('[data-tc-form-producto]');
  if (!form) return;
  var dataEl = form.querySelector('[data-tc-variantes-json]');
  if (!dataEl) return;
  var variantes;
  try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var opciones = form.querySelectorAll('[data-tc-opcion]');
  var inputId = form.querySelector('[data-tc-variant-id]');
  var precioEl = form.querySelector('[data-tc-precio]');
  var precioCompareEl = form.querySelector('[data-tc-precio-compare]');
  var botonComprar = form.querySelector('[data-tc-boton-comprar]');
  var estadoEl = form.querySelector('[data-tc-estado-stock]');
  var galeriaPista = document.querySelector('[data-tc-galeria-pista]');
  var galeriaSlides = document.querySelectorAll('[data-tc-galeria-slide]');
  var galeriaMinis = document.querySelectorAll('[data-tc-galeria-mini]');

  // Formato holandés (coma decimal) para que coincida con los precios que
  // pinta Shopify en el resto de la tienda; se quita el espacio fino que
  // mete el navegador entre el símbolo y la cifra.
  function formatearPrecio(centavos) {
    // Simbolo delante y coma decimal, igual que los precios que pinta Shopify
    // en el resto de la tienda (ej. 69,99 con el simbolo delante).
    var cifra = (centavos / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return '\u20AC' + cifra;
  }

  function valorDeOpcion(el) {
    if (el.tagName === 'SELECT') return el.value;
    var activa = el.querySelector('.tc-activa');
    return activa ? activa.getAttribute('data-tc-swatch-valor') : null;
  }

  function actualizar(moverGaleria) {
    if (!opciones.length) return;
    var seleccion = Array.prototype.map.call(opciones, valorDeOpcion);
    var variante = variantes.find(function (v) {
      return v.options.every(function (opt, i) { return opt === seleccion[i]; });
    });
    if (!variante) return;
    if (inputId) inputId.value = variante.id;
    if (precioEl) precioEl.textContent = formatearPrecio(variante.price);
    if (precioCompareEl) {
      if (variante.compare_at_price && variante.compare_at_price > variante.price) {
        precioCompareEl.textContent = formatearPrecio(variante.compare_at_price);
        precioCompareEl.style.display = '';
      } else {
        precioCompareEl.style.display = 'none';
      }
    }
    if (botonComprar) botonComprar.disabled = !variante.available;

    var comboBoton = document.querySelector('[data-tc-combo-boton]');
    var comboTotal = document.querySelector('[data-tc-combo-total]');
    if (comboBoton && comboTotal) {
      var precioSoporte = parseInt(comboBoton.getAttribute('data-tc-combo-soporte-precio'), 10) || 0;
      comboTotal.textContent = formatearPrecio(variante.price + precioSoporte);
    }
    if (estadoEl) estadoEl.textContent = variante.available ? estadoEl.getAttribute('data-tc-disponible') : estadoEl.getAttribute('data-tc-agotado');

    if (moverGaleria && variante.image && galeriaPista && galeriaSlides.length) {
      var destino = -1;
      galeriaSlides.forEach(function (slide, i) {
        if (slide.getAttribute('data-tc-full').split('?')[0] === variante.image.split('?')[0]) destino = i;
      });
      if (destino > -1) {
        galeriaPista.scrollTo({ left: galeriaSlides[destino].offsetLeft, behavior: 'smooth' });
        galeriaMinis.forEach(function (m, i) { m.classList.toggle('tc-activa', i === destino); });
      }
    }
  }

  opciones.forEach(function (el) {
    if (el.tagName === 'SELECT') {
      el.addEventListener('change', function () { actualizar(true); });
    } else {
      el.querySelectorAll('[data-tc-swatch-valor]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          el.querySelectorAll('[data-tc-swatch-valor]').forEach(function (b) {
            b.classList.remove('tc-activa');
            b.setAttribute('aria-pressed', 'false');
          });
          btn.classList.add('tc-activa');
          btn.setAttribute('aria-pressed', 'true');
          var label = el.closest('.tc-producto-opcion').querySelector('[data-tc-opcion-valor-actual]');
          if (label) label.textContent = btn.getAttribute('data-tc-swatch-valor');
          actualizar(true);
        });
      });
    }
  });
  actualizar(false);
}

function initPromoCarrito() {
  var input = document.querySelector('[data-tc-promo-input]');
  var boton = document.querySelector('[data-tc-promo-boton]');
  if (!input || !boton) return;

  function aplicar() {
    var codigo = input.value.trim();
    if (!codigo) { input.focus(); return; }
    var destino = window.location.pathname.indexOf('/cart') > -1 ? window.location.pathname : '/cart';
    window.location.href = window.Shopify && Shopify.routes && Shopify.routes.root
      ? Shopify.routes.root + 'discount/' + encodeURIComponent(codigo) + '?redirect=' + encodeURIComponent(destino)
      : '/discount/' + encodeURIComponent(codigo) + '?redirect=' + encodeURIComponent(destino);
  }

  boton.addEventListener('click', aplicar);
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') { e.preventDefault(); aplicar(); }
  });
}

// Botón de combo: añade al carrito la cafetera (variante elegida) + el soporte
// en una sola acción, y lleva al carrito.
function initComboCarrito() {
  var boton = document.querySelector('[data-tc-combo-boton]');
  if (!boton) return;
  var etiqueta = boton.querySelector('[data-tc-combo-etiqueta]');
  var textoOriginal = etiqueta ? etiqueta.innerHTML : '';
  var idSoporte = boton.getAttribute('data-tc-combo-soporte-id');
  if (!idSoporte) return;

  boton.addEventListener('click', function () {
    var inputId = document.querySelector('[data-tc-variant-id]');
    var idPrincipal = inputId && inputId.value;
    if (!idPrincipal) return;

    boton.disabled = true;
    if (etiqueta) etiqueta.textContent = boton.getAttribute('data-tc-combo-ocupado') || '...';

    fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [
          { id: Number(idPrincipal), quantity: 1 },
          { id: Number(idSoporte), quantity: 1 }
        ]
      })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        window.location.href = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart';
      })
      .catch(function () {
        boton.disabled = false;
        if (etiqueta) etiqueta.textContent = boton.getAttribute('data-tc-combo-error') || 'Error';
        setTimeout(function () { if (etiqueta) etiqueta.innerHTML = textoOriginal; }, 2600);
      });
  });
}
